import { configureStore } from '@4sure/dashboard-core';

const store = configureStore();

export default store;
